
<template>
  <div class="panel">
    <div class="header">
      <img src="../assets/button.png" class="button-img" @click="seatClientDownload" />
      <div class="slide" >
        <video v-if="videoUrl" id="video" style="width: 100%; height: 100%" controls autoplay loop muted>
          <source :src="videoUrl" type="video/mp4" />
          您的浏览器不支持video标签，建议更新浏览器版本
        </video>
      </div>
    </div>
    <div class="center">
      <img src="../assets/seat-client-download-explain1.png" class="explain-img" />
      <img src="../assets/seat-client-download-explain2.png" class="explain-img" />
      <img src="../assets/seat-client-download-explain3.png" class="explain-img" />
    </div>
    <div style="font-size: 20px">
      广东中标数据科技股份有限公司版权所有<a href="https://beian.miit.gov.cn"> 粤ICP备16019374号</a>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      videoUrl: 'https://xiaowu-index.oss-cn-shenzhen.aliyuncs.com/%E5%9D%90%E5%B8%AD%E5%AE%89%E8%A3%85%E6%95%99%E7%A8%8B.mp4?OSSAccessKeyId=BeVWikfT3aXDZVIB&Expires=1776478825&Signature=k%2BD%2FQ8XQwBGUTrAV7t6yuJpQg5U%3D'//视频地址
    }
  },
  methods: {
    async seatClientDownload () {
      // let { data: url } = await api.get('/api/gx/index/getSeatClientUrl');
      // window.open(url);
    },
    refreshVideoUrl () {
      // api.get('/api/gx/index/getSeatClientVideoUrl').then(res => {
      //   if (res && res.data) {
      //     this.videoUrl = res.data;
      //   }
      // });
    },
  },
  mounted () {
    this.refreshVideoUrl()
  }

}
</script>

<style lang="scss" scoped>
.panel {
  width: 100%;
  height: 100%;
  .header {
    position: relative;
    width: 100%;
    height: 720px;
    background: url('../assets/seat-client-download-header.png') 0 0 / 100% 100% no-repeat;
    .button-img {
      position: absolute;
      top: 240px;
      left: 840px;
    }
    .button-img:hover {
      cursor: pointer;
    }
    .slide {
      width: 900px;
      height: 506px;
      position: absolute;
      top: 410px;
      left: 500px;
      background: #d8d8d8;
      border-radius: 20px;
      overflow: hidden;
    }
  }
  .center {
    width: 1200px;
    margin: auto;
    padding: 180px 0 50px;
    padding-left: 300px;
    .explain-img {
      background-color: red;
      display: block;
    }
  }
}
</style>
